import React, { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿El contenido está actualizado a 2025/2026?',
    a: 'Sí. Este material usa Python 3 — el lenguaje más demandado en el mercado laboral actual — e incluye conexiones con temas contemporáneos como automatización, análisis de datos y desarrollo de aplicaciones.'
  }, {
    q: '¿Qué diferencia tiene con buscar tutoriales en YouTube o Google?',
    a: 'En YouTube encontrás tutoriales técnicos para programadores adultos. El Kit es un sistema pedagógico pensado para docentes que trabajan con adolescentes que nunca programaron, con progresión didáctica, analogías probadas y estrategias para cuando los alumnos se bloquean.'
  }, {
    q: '¿Funciona si usamos otro lenguaje (Java, Scratch, JavaScript)?',
    a: 'Sí. Los conceptos son universales: variables, condicionales, bucles, funciones, estructuras de datos. El Kit usa Python por su claridad, pero las analogías y estrategias didácticas aplican a cualquier lenguaje.'
  }, {
    q: '¿Qué pasa si mis alumnos nunca programaron?',
    a: 'Perfecto. El Tomo 1 empieza desde cero absoluto: qué es un algoritmo, qué es una variable, qué hace print(). No asume conocimientos previos.'
  }, {
    q: '¿Necesito algún programa especial?',
    a: 'No. Solo un lector de PDF. Para los ejercicios de código, Python es gratuito y se puede usar desde el navegador sin instalar nada.'
  }, {
    q: '¿Puedo usarlo en primaria o universidad?',
    a: 'El Kit está optimizado para secundaria técnica (12-18 años), pero los tomos 1-3 funcionan en primaria y los tomos 4-6 en primer año universitario. Más de 300 docentes de nivel superior ya lo usan.'
  }, {
    q: '¿Está adaptado a distintos países?',
    a: 'Sí. Los fundamentos de la programación son iguales en Argentina, México, Colombia, Chile, Perú o cualquier país de habla hispana. Lenguaje neutro, ejemplos universales.'
  }];
  return <section className="py-4 md:py-5 px-3 bg-brand-cardAlt border-b border-white/5" data-id="element-51">
      <div className="max-w-2xl mx-auto" data-id="element-52">
        <h2 className="text-lg md:text-xl font-bold text-center mb-3 text-white uppercase tracking-tight" data-id="element-53">
          ❓ Preguntas frecuentes
        </h2>

        <div className="space-y-1.5" data-id="element-54">
          {faqs.map((faq, index) => <div key={index} className={`bg-brand-card rounded-xl border ${openIndex === index ? 'border-white/15' : 'border-white/5'} overflow-hidden transition-all duration-200`} data-id="element-55">
              <button className="w-full px-3 py-2.5 text-left flex justify-between items-center focus:outline-none" onClick={() => setOpenIndex(openIndex === index ? null : index)} data-id="element-56">
                <span className={`font-medium text-[11px] md:text-xs pr-2 ${openIndex === index ? 'text-white' : 'text-gray-300'}`} data-id="element-57">
                  {faq.q}
                </span>
                {openIndex === index ? <ChevronUp className="w-4 h-4 text-gray-400 shrink-0" data-id="element-58" /> : <ChevronDown className="w-4 h-4 text-gray-600 shrink-0" data-id="element-59" />}
              </button>
              <div className={`px-3 overflow-hidden transition-all duration-200 ease-in-out ${openIndex === index ? 'max-h-96 pb-2.5 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-60">
                <p className="text-[10px] md:text-[11px] text-gray-400 leading-relaxed pt-1.5 border-t border-white/5 font-normal" data-id="element-61">
                  {faq.a}
                </p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}